// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seleted[data-v-5e6fe25c]{background-color:#e0ffff}", ""]);
// Exports
module.exports = exports;
